import { render, staticRenderFns } from "./search-member.vue?vue&type=template&id=437f38f4&scoped=true&"
import script from "./search-member.vue?vue&type=script&lang=js&"
export * from "./search-member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437f38f4",
  null
  
)

export default component.exports